import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const IconContainer = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%) !important",
  zIndex: 1,
  opacity: "10%",
  pointerEvents: "none",
}));

export const BoxContainer = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
}));
